import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
/**
 * Header molecule to be used whenever needed
 */
export class HeaderComponent {
  @Input() hasDashedLine: boolean = true;
}
